import {DonneesMenuItem} from "../../../../val-ammon-composants/val-composants-lib/src/public-api";
import {PermissionsService} from "./permissions.service";
import {APrHabilitation} from "./DonneesPermissions";
import {ValApiResultat} from "../../../../val-ammon-services/val-services-communs-lib/src/public-api";

//Gère les habilitations des items d’un menu
export class GererHabilitationsMenuItems 
{
  //Création
  constructor (private donneesMenuItems: DonneesMenuItem[], private permissionsService: PermissionsService) 
  {
    this.identifiantsDicosMenuItems = [];
    this.donneesHabilitations = null;
  }

  //Identifiants des dicos des menu items
  private identifiantsDicosMenuItems: string[];

  //Données des habilitations
  private donneesHabilitations: APrHabilitation[] | null;

  //Exécute l’habilitation des menu items
  //  Retourne
  //    Données des menu items habilités
  public async Executer () : Promise<DonneesMenuItem[]> 
  {
    this.RecupererIdentifiantsDicosMenuItems (this.donneesMenuItems);

    if (await this.RecupererHabilitations ())
      this.AppliquerHabilitations (this.donneesMenuItems);

    return this.donneesMenuItems;
  }

  //Récupère les identifiants des dicos des menu items
  //  Paramètres
  //    donneesMenuItems : Données des menu items
  private RecupererIdentifiantsDicosMenuItems (donneesMenuItems: DonneesMenuItem[]) : void 
  {
    for (const donneesMenuItem of donneesMenuItems)
    {
      if (donneesMenuItem.dico)
        this.identifiantsDicosMenuItems.push (donneesMenuItem.dico);

      if (donneesMenuItem.items)
        this.RecupererIdentifiantsDicosMenuItems (donneesMenuItem.items);
    }
  }

  //Récupère les habilitations
  //  Retourne
  //    Vrai si la récupération a réussi
  private async RecupererHabilitations () : Promise<boolean> 
  {
    let recuperationReussi: boolean;
    let valApiResultat: ValApiResultat<APrHabilitation[]>;

    try
    {
      valApiResultat = await this.permissionsService.RetournerHabilitations (this.identifiantsDicosMenuItems);

      if (valApiResultat.status === "success")
      {
        this.donneesHabilitations = valApiResultat.resultat;

        recuperationReussi = true;
      }
      else
        recuperationReussi = false;
    }
    catch (erreur)
    {
      recuperationReussi = false;
    }

    return recuperationReussi;
  }

  //Applique les habilitations aux menu items
  //  Paramètres
  //    donneesMenuItems : Données des menu items
  private AppliquerHabilitations (donneesMenuItems: DonneesMenuItem[]) : void 
  {
    let donneesMenuItem: DonneesMenuItem;
    let habilitation: APrHabilitation | undefined;

    for (let index = donneesMenuItems.length - 1; index > -1; index--)
    {
      donneesMenuItem = donneesMenuItems[index];

      if (donneesMenuItem.dico)
      {
        habilitation = this.donneesHabilitations!.find ((hab) => hab.identifiantDico.toUpperCase () === donneesMenuItem.dico!.toUpperCase ());

        if (habilitation && !habilitation.modification)
          donneesMenuItems.splice (index, 1);
        else
        {
          if (habilitation)
            donneesMenuItem.libelle = habilitation.libelle;

          if (donneesMenuItem.items)
            this.AppliquerHabilitations (donneesMenuItem.items);
        }
      }
    }
  }
}
